import { ReactNode, useContext, useEffect, useMemo, useRef } from 'react';

import { NextRouter } from 'next/dist/client/router';
import { Url } from 'next/dist/shared/lib/router/router';
import { RouterContext } from 'next/dist/shared/lib/router-context.shared-runtime';

import {
  appendUtmToUrl,
  extractUtmParamsFromUrl,
  getUtmParams,
  hasUtmSource,
  setUtmParams,
} from '~utils/session/utmSession';

export function UtmRouterProvider({ children }: { children: ReactNode }) {
  const origRouter = useContext(RouterContext);
  const isInitializedRef = useRef(false);

  // UTM 캡처 - 최초 1회만 실행
  useEffect(() => {
    if (typeof window === 'undefined' || isInitializedRef.current) return;
    isInitializedRef.current = true;

    const searchParams = new URLSearchParams(window.location.search);
    const urlUtmParams = extractUtmParamsFromUrl(searchParams);
    if (hasUtmSource(urlUtmParams)) {
      setUtmParams(urlUtmParams);
    }
  }, []);

  const interceptedRouter = useMemo((): NextRouter | null => {
    if (!origRouter) return null;

    const withUtm = (url: Url): Url => {
      const storedUtm = getUtmParams();
      if (storedUtm && hasUtmSource(storedUtm)) {
        return appendUtmToUrl(url);
      }
      return url;
    };

    return {
      ...origRouter,
      push: (href, as, options) => {
        return origRouter.push(withUtm(href), as ? withUtm(as) : as, options);
      },
      replace: (href, as, options) => {
        return origRouter.replace(withUtm(href), as ? withUtm(as) : as, options);
      },
    };
  }, [origRouter]);

  if (!interceptedRouter) {
    return children;
  }

  return <RouterContext.Provider value={interceptedRouter}>{children}</RouterContext.Provider>;
}
